module.exports = __webpack_public_path__ + "static/img/arthroscopy-03.44d322f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-03.jpg
// module id = /9V/
// module chunks = 51